<mat-toolbar fxLayoutAlign="center" color="primary" class="tool-bat-wales-logo mat-elevation-z8">
    <img fxFlex="100%" class="logo" alt="Wales Essential Skills Toolkit" fxHide.gt-sm>
</mat-toolbar>
<mat-nav-list class="main-side-nav-list">
    <a mat-list-item (click)="onSidenavClose()" fxHide.gt-sm
        [routerLink]="loginDisplay ? ['/dashboard'] : ['/welcome']">
        <div fxLayout="row" class="nav-list-item">
            <div>
                <mat-icon>home</mat-icon>
            </div>
            <div>
                <span i18n="@@sidenav-home" name="sidenav-home" class="nav-caption">Home</span>
            </div>
        </div>
    </a>
    <mat-list-item [matMenuTriggerFor]="menu" name="sidenav-menu-information" fxHide.gt-sm *ngIf="loginDisplay">
        <div fxLayout="row" class="nav-list-item">
            <div>
                <mat-icon>error_outline</mat-icon>
            </div>
            <div>
                <a i18n="@@sidenav-info" name="sidenav-info" class="ms-1">Information</a>
            </div>
        </div>
    </mat-list-item>
    <mat-menu name="sidenav-information-menu" #menu="matMenu">
        <button *ngIf="(informationHeader$ | async).hdiw" mat-menu-item 
        routerLink="how-does-it-work" routerLinkActive="active-link" name="sidenav-info-how"
        (click)="onSidenavClose()" i18n="@@button-info-how">How does it work?</button>
        <button *ngIf="(informationHeader$ | async).learnerGuide" mat-menu-item 
        routerLink="learner-guide" routerLinkActive="active-link" name="sidenav-info-learner-guide"
        (click)="onSidenavClose()" i18n="@@button-info-learner-guide">Learner Guide</button>
        <button *ngIf="(informationHeader$ | async).faq" mat-menu-item 
        routerLink="faq" routerLinkActive="active-link" name="sidenav-info-faq"
        (click)="onSidenavClose()" i18n="@@button-info-faq">FAQs</button>
        <button *ngIf="(informationHeader$ | async).tutorResources" mat-menu-item 
        routerLink="tutor-resources" routerLinkActive="active-link" name="sidenav-info-tutor"
        (click)="onSidenavClose()" i18n="@@button-info-tutor">Tutor Resources</button>
        <button *ngIf="(informationHeader$ | async).offlineTool && isDevEnvironment" mat-menu-item 
        name="sidenav-info-download"
        (click)="onSidenavClose()" i18n="@@button-info-download">Download the WEST Offline Assessment Tool</button>
        <button *ngIf="(informationHeader$ | async).externalAssessment && isDevEnvironment" mat-menu-item 
        name="sidenav-info-enter"
        (click)="onSidenavClose()" i18n="@@button-info-enter">Enter external assessment results</button>
        <button *ngIf="(informationHeader$ | async).transferLearning && isDevEnvironment" mat-menu-item 
        name="sidenav-info-transfer"
        (click)="onSidenavClose()" i18n="@@button-info-transfer">Transfer learning from previous provider</button>
        <button *ngIf="(informationHeader$ | async).misAgentTool && isDevEnvironment" mat-menu-item 
        name="sidenav-info-agent"
        (click)="onSidenavClose()" i18n="@@button-info-agent">WEST MIS Agent Tool</button>
    </mat-menu>

    <div *ngIf="isAdmin">
        <a i18n="@@link-users" name="link-users" id="lnkUsers" mat-list-item (click)="goto('users')">
            <span class="nav-caption">Users</span>
        </a>
        <a name="link-groups" id="lnGroups" mat-list-item routerLink="/#" (click)="goto('groups')">
            <span class="nav-caption" i18n="@@groups">Groups</span>
        </a>
        <a name="link-learner-resources" id="lnLearnerResources" mat-list-item routerLink="/#"
            (click)="goto('learner-resources')">
            <span class="nav-caption" i18n="@@learner-resources">Learner resources</span>
        </a>
        <a name="link-reports" id="lnReports" mat-list-item routerLink="/#" 
            (click)="goto('reports')">
            <span class="nav-caption" i18n="@@reports">Reports</span>
        </a>
        <a name="link-organisation-and-centre" id="lnOrganisationAndCentre" mat-list-item
            (click)="goto('organisation-and-centre')" *ngIf="isSystemAdmin">
            <span class="nav-caption" i18n="@@organisation-and-centre">Organisation and Centre</span>
        </a>
    </div>

    <div *ngIf="isTutor">
        <a i18n="@@link-users" name="link-users" id="lnkUsers" mat-list-item (click)="gotoTutorPage('list')">
            <span class="nav-caption">Users</span>
        </a>
        <a name="link-groups" id="lnGroups" mat-list-item routerLink="/#" (click)="gotoTutorPage('groups')">
            <span class="nav-caption" i18n="@@groups">Groups</span>
        </a>
        <a name="link-learner-resources" id="lnLearnerResources" mat-list-item routerLink="/#"
            (click)="gotoTutorPage('learner-resources')">
            <span class="nav-caption" i18n="@@learner-resources">Learner resources</span>
        </a>
        <a name="link-reports" id="lnReports" mat-list-item routerLink="/#" 
            (click)="gotoTutorPage('reports')">
            <span class="nav-caption" i18n="@@reports">Reports</span>
        </a>
    </div>
</mat-nav-list>